import React from "react";
import CustomModal from "../../modal";
import { useTranslation } from "react-i18next";
import {
  convertLanguageToField,
  getVerdadeDesafioCategoryImage,
} from "../../../utils/functions";

import styles from "./modalVerdadeDesafio.module.css";
import useAuth from "../../../hooks/useAuth";
import { useNavigate } from "react-router";

export default function VerdadeDesafioModalCategoria({
  visible,
  setVisible,
  categories,
  selected,
  setSelected,
}) {
  const { t, i18n } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleClose = () => {
    setVisible(false);
  };

  const handleSelect = (index) => {
    if (index !== 0) {
      if (!user?.isPremium) {
        navigate("/premium");
        handleClose();
        return;
      }
    }
    setSelected(index);
    handleClose();
  };

  return (
    <CustomModal
      className={`${styles.modal}`}
      visible={visible}
      handleClose={handleClose}
    >
      <button
        type="button"
        onClick={handleClose}
        className={`${styles.container}`}
      >
        <div className="w-screen rounded-t-2xl bg-[#191919] pt-5">
          <div className="flex justify-center mb-5">
            <h2 className="font-medium">{t("choosecategory")}</h2>
          </div>
          <div className="ps-5 pe-5 pb-5 grid grid-cols-1 gap-5">
            {categories.map((category, index) => {
              const categoryField = convertLanguageToField(
                i18n.language,
                "title"
              );

              return (
                <button
                  type="button"
                  onClick={() => handleSelect(index)}
                  key={`${category.id_categoria}-${index}`}
                  className={`${styles.button} ${
                    selected !== category.id_categoria ? styles.inactive : ""
                  }`}
                >
                  <img
                    className="h-full object-contain"
                    src={getVerdadeDesafioCategoryImage(category.id_categoria)}
                    alt=""
                  />
                  <span className="font-bold ms-3">
                    {category[categoryField]}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </button>
    </CustomModal>
  );
}
